import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    // Ajouter le token d'authentification
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// API de paiement Site B
export const paymentAPI = {
  getProductInfo: () => api.get('/payment/product/info'),
  directCheckout: (originUrl) => api.post('/payment/direct-checkout', { origin_url: originUrl }),
  createCheckout: (data) => api.post('/payment/checkout/create', data),
  getCheckoutStatus: (sessionId) => api.get(`/payment/checkout/status/${sessionId}`),
  getQuote: (quoteId) => api.get(`/payment/quotes/${quoteId}`),
};

export default api;
